import axios from "axios"

const base = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:8000/api/v1",
  headers: { "Content-Type": "application/json" },
})

export const authService = {
  login: (username, password) => base.post("/users/login/", { username, password }),
  register: (username, email, password, password2) =>
    base.post("/users/register/", { username, email, password, password2 }),
  refresh: (refreshToken) => base.post("/users/token/refresh/", { refresh: refreshToken }),
  me: (accessToken) =>
    base.get("/users/me/", { headers: { Authorization: `Bearer ${accessToken}` } }),
  updateProfile: (data, accessToken) =>
    base.patch("/users/me/profile/", data, {
      headers: { Authorization: `Bearer ${accessToken}` },
    }),
}
